
import MoneyChange from "../../../assets/outline/MoneyChange.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MoneyChangeIcon({ className, dataTestid = "MoneyChangeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MoneyChange data-testid={dataTestid} className={classes} {...rest} />
  );
}
